import { ApiService } from '../services/api_service';

const config: any = require('../wips.config.js');
const devFeaturesMap: any = config.devFeaturesMap || {};
export class i18nLang {

    // public static intern_key2 = ['sys', 'tab', 'entity'];
    public static languages = ['de', 'en', 'fr', 'es', 'lb'];
    public static rows: Array<any> = [];
    public static map: any = {};
    public static locales: any = {};
    public static cbUpdateUI: () => void;

    public static init() {
        i18nLang.reset();
        i18nLang.rows.forEach((r: any) => {
            i18nLang.languages.forEach((lg: string) => {
                const key1 = r.intern_key || '';
                const key2 = r.intern_key2 || '';
                if (!i18nLang.map[lg]) {
                    i18nLang.map[lg] = {};
                    i18nLang.map[lg][''] = {};
                }
                if (!i18nLang.map[lg][key2]) {
                    i18nLang.map[lg][key2] = {};
                }
                i18nLang.map[lg][key2][key1] = r[lg];
            });
        });
        i18nLang.setLocales();
    }

    public static setLocales() {
        const uiLang = i18nLang.getUILang();
        i18nLang.locales = { ...i18nLang.map[uiLang] };
        try {
            const jsonObj = require('./locale_' + uiLang + '.json');
            if (jsonObj) {
                i18nLang.locales = { ...i18nLang.locales, ...jsonObj };
            }
        } catch (e) { }
    }

    public static reset(clean = false) {
        if (clean) {
            i18nLang.rows = [];
        }
        i18nLang.map = {};
        i18nLang.locales = {};
    }

    // Bitte verwenden LANGUAGE_SELECTED, die Sprachauswahl an Komponenten zu übergeben, um dort ein Update auszulösen.

    public static getUILang() {
        if (!devFeaturesMap.N207_MEHRSPRACHIGKEIT) {
            return 'de';
        }
        const module = ApiService.module || '';
        const uiLangKey = `UILang_${module}`;
        let lang = localStorage.getItem(uiLangKey);
        if (!lang) {
            lang = navigator.language;
            if (i18nLang.languages.indexOf(lang) === -1) {
                lang = 'de';
            }
            localStorage.setItem(uiLangKey, lang);
        }
        return lang;
    }

    public static setUILang(lang: string) {
        const module = ApiService.module || '';
        const uiLangKey = `UILang_${module}`;
        localStorage.setItem(uiLangKey, lang);
    }
}
